import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { getStockQuantityColumns } from './stockQuantityColumns';

import type { TypeStockSku } from '~/types/stock.types';

/**
 * [재고관리 > 상품별 조회] 페이지 테이블
 */
const getStockSkuColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeStockSku>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'alterCode',
      header: '상품 바코드',
      size: 150,
    },
    {
      accessorKey: 'skuCode',
      header: 'SKU코드',
      size: 140,
    },
    {
      accessorKey: 'clusterName',
      header: '보관 센터',
      size: 80,
    },
    {
      accessorKey: 'skuName',
      header: '상품명',
      minSize: 210,
      meta: { flex: true },
    },
    {
      accessorKey: 'temperatureType',
      header: '보관 유형',
      size: 92,
    },
    ...getStockQuantityColumns<TypeStockSku>(),
  ];

  return { columnDefs };
};

export default getStockSkuColumnDefs;
